import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { AuthGuard } from '../../components/dashboard/AuthGuard';
import { authClient, clearAuthToken } from '../../lib/auth-client';

const DASHBOARD_LINKS = [
  { to: '/dashboard', label: 'Overview', end: true },
  { to: '/dashboard/orders', label: 'My Orders' },
  { to: '/dashboard/invoices', label: 'Invoices' },
  { to: '/dashboard/documents', label: 'Documents' },
  { to: '/dashboard/support', label: 'Support' },
  { to: '/dashboard/profile', label: 'Profile' },
];

export default function DashboardLayout() {
  const navigate = useNavigate();

  async function handleSignOut() {
    await authClient.signOut();
    clearAuthToken();
    navigate('/login');
  }

  return (
    <AuthGuard>
      <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[220px_1fr]">
          <aside>
            <nav className="flex gap-2 overflow-x-auto md:flex-col md:overflow-visible">
              {DASHBOARD_LINKS.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.end}
                  className={({ isActive }) =>
                    `whitespace-nowrap rounded px-3 py-2 text-sm font-medium transition-colors ${
                      isActive ? 'bg-seal-blue text-white' : 'text-ink/70 hover:bg-ink/5'
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
              <button
                onClick={handleSignOut}
                className="mt-4 whitespace-nowrap rounded px-3 py-2 text-left text-sm font-medium text-red-600 transition-colors hover:bg-red-50"
              >
                Sign Out
              </button>
            </nav>
          </aside>
          <main>
            <Outlet />
          </main>
        </div>
      </div>
    </AuthGuard>
  );
}
